import { z } from "zod";

export type SsoLink = z.infer<typeof SsoLinkSchema>;
export const SsoLinkSchema = z.object({
  message: z.string().optional(),
  token: z.string().optional(),
  url: z.string().optional(),
});
